<div #progressBar class="bar" aria-labelledby="progress-bar-label">
  <div class="completed" [style.width.px]="completedWidth"></div>
</div> 